import { ElNotification } from 'element-plus';

type Position = 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';

function notifyError(message: string, position?: Position) {
  if (!message) return;

  ElNotification({
    title: '成功',
    message,
    type: 'success',
    position: position || 'top-right',
  });
}

export default notifyError;
